import React from 'react';
import { NavLink } from 'react-router-dom';

import imgHallChadwickLogo from '../images/powered-by-hall-chadwick-forensics.png';
import imgXpediteLogo from '../images/xpedite-logo.png';

const logos = (props) => {

	let logo_link = '/';
	if(props.xplink !== null && props.xplink !== undefined) {
		logo_link = props.xplink;
	}

	return (
		<section className='page__section page__section--white'>

			<div className='wrapper wrapper--narrow clearfix'>

				<div className='page__header__logo page__header__logo--left pull-left'>
					<h1 className='page__heading'>
						<a href='http://hallchadwickmelb.com.au/' rel='noopener noreferrer' target='_blank'>
							<img src={imgHallChadwickLogo} alt='powered by Hall Chadwick Forensics' />
						</a>
					</h1>
				</div>

				<div className='page__header__logo page__section__w30 page__header__logo--right pull-right'>
					<h2 className='page__heading'>
						<NavLink to={logo_link}>
							<img src={imgXpediteLogo} alt='Xpedite' />
						</NavLink>
					</h2>
				</div>

			</div>

		</section>
	);
}

export default logos;


// WEBPACK FOOTER //
// ./src/Blocks/Logos.js